import React from 'react'

import styled from 'styled-components'

import { BrandColors } from 'src/utilities/Colors'

import { Body2, Body2Regular } from '../blocks/Typography'

const CheckmarkSVG = ({
  backgroundColor,
  foregroundColor
}: {
  backgroundColor?: string
  foregroundColor?: string
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    fill='none'
    viewBox='0 0 24 24'
  >
    <circle cx='12' cy='12' r='12' fill={backgroundColor}></circle>
    <path
      fill={foregroundColor}
      d='M10.82 17h-.02a.734.734 0 01-.526-.246l-4.07-4.512a.805.805 0 01.031-1.105.727.727 0 011.058.034l3.554 3.939 6.887-6.893a.726.726 0 011.058.024.805.805 0 01-.023 1.104l-7.432 7.438a.733.733 0 01-.518.217z'
    ></path>
  </svg>
)

const ChecklistItemWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;

  p {
    flex: 1;
  }
`

const ChecklistCheckmark = styled.div`
  width: 24px;
  height: 24px;
  margin-right: 1rem;
  margin-top: 0.15rem;
`

const ChecklistItem = ({
  backgroundColor = BrandColors.pigeon200,
  foregroundColor = BrandColors.black,
  text,
  textColor = BrandColors.black
}: {
  backgroundColor?: string
  foregroundColor?: string
  text: string | React.ReactNode
  textColor?: string
}) => {
  return (
    <ChecklistItemWrapper>
      <ChecklistCheckmark>
        <CheckmarkSVG
          backgroundColor={backgroundColor}
          foregroundColor={foregroundColor}
        />
      </ChecklistCheckmark>
      {typeof text === 'string' ? (
        <Body2Regular
          style={{
            textWrap: 'pretty'
          }}
          color={textColor}
          dangerouslySetInnerHTML={{ __html: text }}
        ></Body2Regular>
      ) : (
        <>{text}</>
      )}
    </ChecklistItemWrapper>
  )
}

export default ChecklistItem
